import { render } from "./index.vue?vue&type=template&id=83f6b972&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=83f6b972&lang=scss"
import "./index.vue?vue&type=style&index=1&id=83f6b972&lang=scss&scoped=true"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f6b972"]])

export default __exports__